export default __webpack_public_path__ + "static/media/meet@4x.7e054187.png";